import { Helmet } from 'react-helmet-async';
import { alpha, styled } from '@mui/material/styles';
import { Container, Card } from '@mui/material';
import { LeftHome, PasswordResetStep } from '../../sections/auth';
import { SetNewPassword } from '../../sections/auth/forget-password';
import Header from './Header';

const APP_BAR_MOBILE = 40;
const APP_BAR_DESKTOP = 60;

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: APP_BAR_MOBILE + 20,
  paddingBottom: 20,
  [theme.breakpoints.up('sm')]: {
    paddingTop: APP_BAR_DESKTOP + 20,
  },
  [theme.breakpoints.up('lg')]: {
    paddingBottom: 40,
  },
}));

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '87.6vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const LIGHT_GRAY = '#f7f7f7';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '' : LIGHT_GRAY,
  boxShadow: `
  -4px -4px 5px ${alpha(theme.palette.primary.darker, 0.1)},
  4px 4px 2px ${alpha(theme.palette.primary.darker, 0.15)}
`
}));

export default function SetNewPasswordPage() {
  return (
    <>
      <Helmet>
        <title> ማረጋገጥ | የሰ/ሸ/ሃ/መ/አ/ስርዓት </title>
      </Helmet>

      <StyledRoot>
        <StyledContainer maxWidth="sm">
          <StyledContent>
            <StyledCard
              sx={{
                p: 5,
                px: { xs: 1, sm: 5 }, 
                pt: 0,
              }}
            >
              <Header />
              <PasswordResetStep activeStep={2} />
              <SetNewPassword />
            </StyledCard>
          </StyledContent>
        </StyledContainer>
        <LeftHome />
      </StyledRoot>
    </>
  );
}
